module.exports = __webpack_public_path__ + "static/media/caret-square-left.8ed5a3b4.svg";